export default __webpack_public_path__ + "static/media/info-circle-fill 16px.486050b6.svg";